import React from 'react';

const ForgotPassword = ({history}) => {

    return(
        <div className="account-body accountbg" style={{width: '100vw'}}>
            <div className="container">
                <div className="row vh-100 d-flex justify-content-center">
                    <div className="col-12 align-self-center">
                        <div className="row">
                            <div className="col-lg-5 mx-auto">
                                <div className="card">
                                    <div className="card-body p-0 auth-header-box">
                                        <div className="text-center p-3">
                                            {/* <a href="index.html" className="logo logo-admin">
                                                <img src="assets/images/logo-sm-dark.png" height="50" alt="logo" className="auth-logo" />
                                            </a> */}
                                            <h4 className="mt-3 mb-1 fw-semibold text-white font-18">Reset Password For Typing Center</h4>   
                                            <p className="text-muted  mb-0">Enter your Email and instructions will be sent to you!</p>  
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <form className="form-horizontal auth-form" action="index.html">                
                                            <div className="form-group mb-2">
                                                <label className="form-label" htmlFor="username">Email</label>
                                                <div className="input-group">                                                                                         
                                                    <input type="email" className="form-control" placeholder="Enter Email" />
                                                </div>                                    
                                            </div> 
                
                                            <div className="form-group mb-0 row">
                                                <div className="col-12 mt-2">
                                                    <button className="btn btn-primary w-100 waves-effect waves-light" type="button">Reset <i className="fas fa-sign-in-alt ms-1"></i></button>
                                                </div>
                                            </div>                            
                                        </form>                               
                                        <p className="text-muted mb-0 mt-3">Remember It ? <span className="text-primary ms-2 c-pointer" onClick={() => history.push('/')}>Sign in here</span></p>
                                    </div>
                                    <div className="card-body bg-light-alt text-center">
                                        <span className="text-muted d-none d-sm-inline-block">Aamer © 2021</span>                                            
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;